export default __webpack_public_path__ + "static/media/wi-wallet.005ccd59.jpg";